<template>
<w-sliding-popup type="setting" ref="slidingPopup" width="560px" :title="allowPortTitle" @close="closePopup">
  <el-form slot="content" :model="portInfo" :rules="rules" label-position="top" :ref="formName">
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="인증대상">
          <el-select v-model="authTarget" style="width:100%" @change="onAuthTargetChange">
          <el-option v-for="item in targetList" :key="item.label" :label="item.label" :value="item.label"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="인증방법">
          <el-select v-model="authType" style="width:100%">
            <el-option label="IP, MAC인증" value="A"></el-option>
            <el-option label="IP 인증" value="IA"></el-option>
            <el-option label="MAC 인증" value="MA"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="!ipAddrDisabled">
      <el-col :span="24">
        <el-form-item label="IP 주소" prop="ipaddress">
          <el-input v-model="portInfo.ipaddress" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="!macDisabled">
      <el-col :span="24">
        <el-form-item label="MAC 주소" prop="macaddress">
          <el-input v-model="portInfo.macaddress" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form-item label="허용 이유" prop="controlDesc">
          <el-input v-model="portInfo.controlDesc" placeholder="입력해 주세요."></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item label="허용 시작 시각" prop="startTime" ref="startTimeField">
          <el-time-select v-model="portInfo.startTime" :clearable="false" :editable="false" :picker-options="timePickerOptions"/>
        </el-form-item>
      </el-col>
      <el-col :span="12">
        <el-form-item label="허용 종료 시각" prop="endTime" ref="endTimeField" >
          <el-time-select v-model="portInfo.endTime" :clearable="false" :editable="false" :picker-options="timePickerOptions"/>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
  <el-row slot="footer" type="flex" justify="center">
    <el-button size="large" type="solid" @click="savePortAllow">저장</el-button>
    <el-button size="large" @click="closePopup">취소</el-button>
  </el-row>
</w-sliding-popup>
</template>

<script>
import clone from 'lodash/clone';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import findIndex from 'lodash/findIndex';
import ServerSettingAPI from '@/api/settings/server/server-settings';
import { validateIpv4, validateMacAddress } from '@/utils/string';
import moment from 'moment';
import msgUtil from '@/utils/message';

const MANUAL_LABEL = '수동설정';
export default {
  name: 'WExceptControlPopup',
  data() {
    return {
      popupType: 'ADD',
      selectedPort: {},
      selectPhysicalNode: {},
      formName: 'portInfoForm',
      certificateType: '',
      allowPortTitle: '',
      startType: 'startTime',
      endType: 'endTime',
      authType: null,
      ipAddrDisabled: false,
      macDisabled: false,
      authTarget: '',
      timePickerOptions: { start: '00:00', step: '00:15', end: '23:45' },
      portInfo: {
        label: '',
        startTime: null,
        endTime: null,
        ipaddress: '',
        macaddress: '',
        controlDesc: '',
      },
      targetList: [],
      rules: {
        ipaddress: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateIp,
          },
        ],
        macaddress: [
          {
            required: true,
            trigger: 'blur',
            validator: this.validateMacAddr,
          },
        ],
        startTime: [
          {
            trigger: 'blur',
            validator: this.validateStartTime,
          },
        ],
        endTime: [
          {
            trigger: 'blur',
            validator: this.validateEndTime,
          },
        ],
      },
    };
  },
  watch: {
    authType: {
      handler() {
        if (!isNil(this.authType)) {
          switch (this.authType) {
            case 'IA' :
              this.portInfo.macaddress = '';
              this.ipAddrDisabled = false;
              this.macDisabled = true;
              break;
            case 'MA' :
              this.portInfo.ipaddress = '';
              this.ipAddrDisabled = true;
              this.macDisabled = false;
              break;
            default:
              this.ipAddrDisabled = false;
              this.macDisabled = false;
              break;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    /**
     * 포트 접근 허용 팝업을 연다.
     * @author Ju
     * @param  {[type]} type 추가/수정 여부
     * @param  {[type]} data 수정 객체 정보
     */
    open(type, data, selectPhysicalNode, selectedPort) {
      this.loadAuthTargetList();
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        this.selectPhysicalNode = selectPhysicalNode;
        this.selectedPort = selectedPort;
        this.popupType = type;
        if (type === 'ADD') {
          this.allowPortTitle = `[${this.selectedPort.label}/${this.selectedPort.portNumber}] 포트 접근 허용 설정`;
          this.portInfo.startTime = '00:00';
          this.portInfo.endTime = '23:00';
          this.authType = 'A';
        } else {
          this.allowPortTitle = `[${this.selectedPort.label}/${this.selectedPort.portNumber}] 포트 접근 허용 정보`;
          data.startTime = this.parseDateToString(data.startTime);
          data.endTime = this.parseDateToString(data.endTime);
          this.portInfo = data;
          this.authType = data.label;
        }
      });
    },
    closePopup() {
      this.$refs[this.formName].resetFields();
      this.portInfo = {
        label: '',
        startTime: null,
        endTime: null,
        ipaddress: '',
        macaddress: '',
        controlDesc: '',
      };
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 인증 대상 목록을 로드한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadAuthTargetList() {
      const manual = { label: MANUAL_LABEL };
      ServerSettingAPI.getPortcontrolAllowTarget({ serverId: this.serverId }).then((response) => {
        if (response.data.success) {
          const data = isEmpty(response.data.data) ? [] : response.data.data;
          data.unshift(manual);
          this.targetList = data;
          this.authTarget = this.targetList[0].label;
        } else {
          this.targetLit = [manual];
        }
      }).catch(() => {
        this.targetLit = [manual];
      });
    },
    /**
     * 시간 데이터를 문자열로 치환하여 반환한다.
     * @author Ju
     * @param  {[type]} value [description]
     * @return {String}       [description]
     */
    parseDateToString(value) {
      if (isNil(value)) {
        return null;
      }
      return moment(new Date(value)).format('HH:mm');
    },
    /**
     * 시간 문자열을 Date 객체로 반환한다.
     * @author Ju
     * @param  {[type]} type     시작/종료 여부 (start / end)
     * @param  {[type]} value    시간 문자열
     * @param  {[type]} baseDate Date 객체로 변환할 기준 date
     * @return {Date}
     */
    parseStringToDate(type, value, baseDate) {
      if (isNil(value) || value === '') {
        return null;
      }
      const timeArr = value.split(':');
      const seconds = type === 'start' ? 0 : 59;
      const date = moment(baseDate).hours(timeArr[0]).minutes(timeArr[1]).seconds(seconds);
      return date.toDate();
    },
    onAuthTargetChange(value) {
      if (value !== MANUAL_LABEL) {
        const index = findIndex(this.targetList, (item) => item.label === value);
        const selectedTarget = this.targetList[index];
        this.portInfo.ipaddress = selectedTarget.ipaddress;
        this.portInfo.macaddress = selectedTarget.macaddress;

        this.$refs[this.formName].validateField('ipaddress');
        this.$refs[this.formName].validateField('macaddress');
      }
    },
    /**
     * [savePortAllow 포트 접근 허용 항목을 추가 또는 수정하여 저장한다.]
     * @author yelim
     */
    savePortAllow() {
      this.$refs[this.formName].validate((valid) => {
        if (valid) {
          const saveParams = clone(this.portInfo);
          const baseDate = new Date();
          saveParams.startTime = this.parseStringToDate('start', saveParams.startTime, baseDate);
          saveParams.endTime = this.parseStringToDate('end', saveParams.endTime, baseDate);

          // 인증 방법에 따른 flag 설정
          if (this.authType === 'A') {
            saveParams.checkIpFlag = 'Y';
            saveParams.checkMacFlag = 'Y';
          } else if (this.authType === 'IA') {
            saveParams.checkIpFlag = 'Y';
            saveParams.checkMacFlag = 'N';
          } else {
            saveParams.checkIpFlag = 'N';
            saveParams.checkMacFlag = 'Y';
          }
          saveParams.label = this.authType;
          saveParams.portNumber = this.selectedPort.portNumber;
          saveParams.serverId = this.selectedPort.serverId;

          const target = '포트 접근 허용 IP/MAC 설정';
          if (this.popupType === 'ADD') {
            const action = msgUtil.action.ADD;
            ServerSettingAPI.insertPortcontrolAllow(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          } else {
            const action = msgUtil.action.SAVE;
            ServerSettingAPI.updatePortcontrolAllow(saveParams).then((response) => {
              if (response.data.success) {
                this.$message(msgUtil.getResultMsgData(action, target, true));
                this.$emit('reload-data');
                this.closePopup();
              } else {
                this.$message(msgUtil.getResultMsgData(action, target, false));
              }
            }).catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
          }
        }
      });
    },
    validateIp(rule, value, callback) {
      if (!this.ipAddrDisabled) {
        if (isNil(this.portInfo.ipaddress) || this.portInfo.ipaddress === '') {
          callback(new Error('값을 입력해주세요'));
        }
        if (validateIpv4(this.portInfo.ipaddress)) {
          callback();
        } else {
          callback(new Error('올바른 IPv4 주소형식을 입력해주세요'));
        }
      } else {
        callback();
      }
    },
    validateMacAddr(rule, value, callback) {
      if (!this.macDisabled) {
        if (isNil(this.portInfo.macaddress) || this.portInfo.macaddress === '') {
          callback(new Error('값을 입력해주세요'));
        }
        if (validateMacAddress(this.portInfo.macaddress)) {
          callback();
        } else {
          callback(new Error('올바른 MAC 주소형식을 입력해주세요'));
        }
      } else {
        callback();
      }
    },
    /**
     * 허용 시작 시각 validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateStartTime(rule, value, callback) {
      this.$refs.endTimeField.clearValidate();
      if (isNil(this.portInfo.startTime) || this.portInfo.startTime === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!isNil(this.portInfo.endTime) && this.portInfo.startTime >= this.portInfo.endTime) {
        if (this.validateAllowTime()) {
          callback(new Error('종료 시각보다 이전 시각으로 설정해주세요.'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    /**
     * 허용 종료 시각 validator
     * @author Ju
     * @param  {[type]}   rule     [description]
     * @param  {[type]}   value    [description]
     * @param  {Function} callback [description]
     * @return {[type]}            [description]
     */
    validateEndTime(rule, value, callback) {
      this.$refs.startTimeField.clearValidate();
      if (isNil(this.portInfo.endTime) || this.portInfo.endTime === '') {
        callback(new Error('값을 입력해주세요'));
      } else if (!isNil(this.portInfo.startTime)) {
        if (this.validateAllowTime()) {
          callback(new Error('시작 시각보다 이후 시각으로 설정해주세요.'));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    /**
     * 허용 시간 validation을 체크한다. (시작과 종료 시각 범위가 맞는지 확인.)
     * @author Ju
     * @return {[type]} [description]
     */
    validateAllowTime() {
      const baseDate = new Date();
      const startTime = this.parseStringToDate('start', this.portInfo.startTime, baseDate);
      const endTime = this.parseStringToDate('end', this.portInfo.endTime, baseDate);
      return startTime >= endTime;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/SecuritySettings/ExceptControlView/popup/ExceptControlPopup.vue